import { CountryType } from '@fd/common/api/fetchCountryList';
import FlagIcon from '@fd/frontend/assets/icons/FlagIcon';
import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import Flex from '@fd/frontend/components/ui/Flex';
import CustomSelect from '@fd/frontend/components/ui/CustomSelect';
import static_cities from '@fd/frontend/model/static_cities';
import { static_countries } from '@fd/frontend/model/static_countries';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';
import countryCodeToFlagEmoji from 'country-code-to-flag-emoji';
import {
  components,
  MultiValue,
  OptionProps,
  SingleValueProps,
} from 'react-select';

export default function LocationCard() {
  return (
    <OptionField.Card>
      <OptionField.Body>
        <OptionField.Title>Location</OptionField.Title>
        <OptionField.Description>
          To control where your IPs appear to be located, enabling access to
          region-specific content.
        </OptionField.Description>
      </OptionField.Body>
      <OptionField.Body>
        <CountrySelect />
        <CitySelect />
      </OptionField.Body>
    </OptionField.Card>
  );
}

function CountrySelect() {
  const { country, setCountry } = useProxyPoolCreationForm();

  const handleChange = (option: CountryType | null) => {
    if (option !== null) setCountry(option);
    else setCountry(undefined);
  };

  return (
    <CustomSelect
      value={country}
      isMulti={false}
      isClearable={true}
      onChange={handleChange}
      getOptionLabel={(c) =>
        `${countryCodeToFlagEmoji(c.countryCode)} ${c.countryName}`
      }
      getOptionValue={(c) => c.countryCode}
      options={static_countries}
      placeholder="Select countries"
      components={{
        SingleValue,
        Option,
      }}
    />
  );
}

const SingleValue = (props: SingleValueProps<CountryType>) => {
  const country = props.getValue()[0];
  if (!country) return <components.SingleValue {...props} />;

  return (
    <components.SingleValue {...props}>
      <Flex.Row gap="2">
        <FlagIcon countryCode={country.countryCode} className="rounded-md" />
        <span>{country.countryName}</span>
      </Flex.Row>
    </components.SingleValue>
  );
};

const Option = (props: OptionProps<CountryType>) => {
  const country = props.data;
  if (!country) return <components.Option {...props} />;

  return (
    <components.Option {...props}>
      <Flex.Row gap="2">
        <FlagIcon countryCode={country.countryCode} className="rounded-md" />
        <span>{country.countryName}</span>
      </Flex.Row>
    </components.Option>
  );
};

type CityOptionType = {
  value: string;
};

function CitySelect() {
  const { country, cities, setCities } = useProxyPoolCreationForm();

  const handleChange = (options: MultiValue<CityOptionType> | null) => {
    if (options !== null) setCities(options.map((i) => i.value));
  };

  return (
    <CustomSelect
      value={cities.map((c) => ({ value: c }))}
      onChange={handleChange}
      getOptionLabel={(o) => o.value}
      options={
        country
          ? static_cities[country.countryCode as keyof typeof static_cities]
          : []
      }
      placeholder="Select cities (optional)"
      isDisabled={!country}
      isMulti
    />
  );
}
